import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import WrappedCell from './WrappedCell'

import './style.scss'

const areEqual = (prevProps, nextProps) => _.isEqual(prevProps, nextProps)

// eslint-disable-next-line no-unused-vars
const BodyRow = ({ cells, extraClasses }) => {
  // console.log(`Angelo Log ~ file: BodyRow.jsx ~ line 10 ~ BodyRow ~ extraClasses111`, extraClasses)
  // // eslint-disable-next-line no-unused-vars
  // const [newRow, setNewRow] = useState(() => {
  //   console.log(`Angelo Log ~ file: BodyRow.jsx ~ line 11 ~ newRow ~ row, extraClasses`, extraClasses)
  //   return extraClasses
  // })
  // console.log(`Angelo Log ~ file: BodyRow.jsx ~ line 16 ~ BodyRow ~ newRow`, newRow)
  // const { cells } = row
  // console.log(`Angelo Log ~ file: BodyRow.jsx ~ line 21 ~ BodyRow ~ rowData`, rowData)
  return (
    <div
      role="row"
      className={classnames('fil-table--body-row', {
        // 'fil-table-row--selected': !!rowProps.selected,
        [extraClasses]: extraClasses
      })}
      aria-label="row"
    >
      {cells.map((cell, cellIndex) => {
        const { element, style, ...restCellProps } = cell
        return <WrappedCell style={style} cell={element} cellIndex={cellIndex} key={`table_cell_${cellIndex}`} cellProps={restCellProps} />
      })}
    </div>
  )
}

BodyRow.propTypes = {
  cells: PropTypes.array.isRequired,
  // rowData: PropTypes.object.isRequired,
  extraClasses: PropTypes.string
}

BodyRow.defaultProps = {
  extraClasses: ''
}

export default React.memo(BodyRow, areEqual)
